import { REGEX } from '@/constants/constants'
import { localeHelper } from '@/utils'

const requiredField = (v) => !!v || localeHelper.getMessage('error.requiredField')

const invalidFieldFormat = (v) => (v && REGEX.INVALID_CHARACTERS.test(v)) || localeHelper.getMessage('error.invalidFieldFormat')

const notAllowMultipleSpace = (v) => (v && REGEX.NOT_ALLOW_MULTIPLE_SPACE.test(v)) || localeHelper.getMessage('error.multipleSpace')

const email = (v) => (v && REGEX.EMAIL.test(v)) || localeHelper.getMessage('error.invalidEmail')

const numbersOnly = (v) => (v && REGEX.NUMERIC.test(v)) || localeHelper.getMessage('error.numbersOnly')

const minOneNumeric = (v) => (v && REGEX.MIN_ONE_NUMERIC.test(v)) || localeHelper.getMessage('error.minOneNumeric')

const minPasswordLength = (v) => (v && v.length >= 6) || localeHelper.getMessage('error.minPasswordLength')

const confirmPassword = (passwordToCheck, originalPassword) =>
  passwordToCheck && passwordToCheck.length >= originalPassword.length && (passwordToCheck === originalPassword || localeHelper.getMessage('error.passwordsNoMatch'))

const minMobileLength = (v) => (v && v.length >= 8) || localeHelper.getMessage('error.minMobileLength')

/* RULESETS */
const requiredRules = [requiredField, invalidFieldFormat, notAllowMultipleSpace]
const emailRules = [...requiredRules, email]
const passwordRules = [...requiredRules, minOneNumeric, minPasswordLength]
const mobileNumberRules = [...requiredRules, numbersOnly, minMobileLength]
/* END RULESETS */

export default {
  requiredRules,
  passwordRules,
  mobileNumberRules,
  emailRules,
  email,
  numbersOnly,
  requiredField,
  minOneNumeric,
  confirmPassword,
  minPasswordLength
}
